export default {
    bind: function (el) {
        setTimeout( function(){
            el.style.height = `${el.scrollHeight}px` 
        }, 200)
    },
    update:function(el){
        el.style.height = "50px"
        el.style.height = `${el.scrollHeight}px`
    }
}
